var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("🍌")]),_c('h1',[_vm._v("404")]),_c('p',[_vm._v("???")]),_c('hr',{attrs:{"id":"top-hr"}}),_c('p',{staticClass:"not-found-container"},[_vm._v("You don't belong here.")])])
}]

export { render, staticRenderFns }